import { AvailableDeliveryMethodsDetail } from "interfaces/session/ShoppingCart";
import { currency } from "../../../util/helper/currency";
import { selectedDeliveryMethodDetails } from "./selectedDeliveryMethodDetails";

export function minimumShippingCost(selectedDeliveryMethod: string,
  availableDeliveryMethodsDetails: AvailableDeliveryMethodsDetail[], locale?: string) {
  const deliverMethodDetails: any = selectedDeliveryMethodDetails(selectedDeliveryMethod, availableDeliveryMethodsDetails);
  if (deliverMethodDetails && deliverMethodDetails.minimumCostForFreeDelivery) {
    return currency(deliverMethodDetails.minimumCostForFreeDelivery, locale);
  }
  return "FREE";
}
